export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement10.e3aa0e66.png";